import { Divider, Icon } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import { FEEDBACK_NAVIGATION_WIDTH } from "@/components/pages_logged_in/roleplays/details/scenario/session/constants";
import { Clickable } from "@/components/pieces/interaction/Clickable";

interface FeedbackNavigationButtonsProps {
  onClose: () => void;
  onNavigate: (direction: "up" | "down") => void;
  isXs?: boolean;
}

export function FeedbackNavigationButtons({
  onClose,
  onNavigate,
  isXs = false,
}: FeedbackNavigationButtonsProps) {
  const iconSize = isXs ? 22 : 16;

  return (
    <Flex
      backgroundColor="white"
      className="bas"
      p={1}
      css={{
        position: "absolute",
        top: isXs ? "16px" : "24px",
        left: isXs ? "none" : `-${FEEDBACK_NAVIGATION_WIDTH}px`,
        right: isXs ? "16px" : "none",
        borderTopLeftRadius: isXs ? 0 : 6,
        borderBottomLeftRadius: isXs ? 0 : 6,
        borderRadius: isXs ? 6 : undefined,
      }}
      flexDirection={isXs ? "row-reverse" : "column"}
    >
      <Clickable onClick={onClose}>
        <Box p={2}>
          <Icon
            icon={isXs ? "cross" : "double-chevron-right"}
            size={iconSize}
          />
        </Box>
      </Clickable>

      <Divider />
      <Clickable onClick={() => onNavigate("up")}>
        <Box p={2}>
          <Icon icon="chevron-up" size={iconSize} />
        </Box>
      </Clickable>
      <Clickable onClick={() => onNavigate("down")}>
        <Box p={2}>
          <Icon icon="chevron-down" size={iconSize} />
        </Box>
      </Clickable>
    </Flex>
  );
}
